// No dependencies, so the app can import it.
export type InlineCitationRefs = {
  assumptionKeys: string[];
  referencedIds: string[];
  versionIds: string[];
};

export const INLINE_CITATIONS_TAG_NAME = "citations";

// Shared by stripping and validation so both agree on what counts as a tag.
export const INLINE_CITATIONS_OPEN_TAG_PATTERN = `<${INLINE_CITATIONS_TAG_NAME}(?=[\\s/>])(?:"[^"]*"|'[^']*'|[^>"'])*>`;

// Leading spaces and tabs go with the tag, so stripping leaves no gap before the line end.
const STRIP_REGEX = new RegExp(
  `[ \\t]*${INLINE_CITATIONS_OPEN_TAG_PATTERN}|<\\/${INLINE_CITATIONS_TAG_NAME}\\s*>`,
  "gi",
);

export function parseInlineCitationList(value: string | undefined): string[] {
  if (!value) return [];
  return value
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

export function stripInlineCitations(markdown: string): string {
  return markdown.replace(STRIP_REGEX, "");
}
